var map = {
	"./arrow-down-blue.svg": 455,
	"./arrow-down-grey.svg": 456,
	"./arrow-right-white.png": 457,
	"./arrow-right.svg": 458,
	"./bitcoin-logo.png": 187,
	"./blue-loader.svg": 188,
	"./circle-grey.svg": 459,
	"./circle.svg": 460,
	"./coinbaseWalletIcon.svg": 128,
	"./dropdown-blue.svg": 461,
	"./dropdown.svg": 462,
	"./dropup-blue.svg": 463,
	"./ethereum-logo.png": 464,
	"./fortmaticIcon.png": 130,
	"./link.svg": 465,
	"./magnifying-glass.svg": 466,
	"./menu.svg": 467,
	"./metamask.png": 189,
	"./plus-blue.svg": 468,
	"./plus-grey.svg": 469,
	"./portisIcon.png": 127,
	"./question-mark.svg": 470,
	"./question.svg": 471,
	"./spinner.svg": 472,
	"./trustWallet.png": 473,
	"./unisat.png": 474,
	"./walletConnectIcon.svg": 129,
	"./x.svg": 475
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 177;